module.exports = __webpack_public_path__ + "static/media/TIBET.3f00c818.svg";